"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes"));

require("../styles/_assets-summary-footer.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getTotalSize(assets) {
  return assets.reduce(function (_ref, asset) {
    var size = _ref.size;

    try {
      var _JSON$parse = JSON.parse(asset.metaData),
          assetSize = _JSON$parse.size;

      return {
        size: size + (assetSize || 0)
      };
    } catch (e) {
      return {
        size: size
      };
    }
  }, {
    size: 0
  });
}

function AssetsSummaryFooter(_ref2) {
  var assets = _ref2.assets;
  var total = getTotalSize(assets);
  var totalQuantity = "".concat(assets.length, " Video Asset").concat(assets.length !== 1 ? 's' : '');
  var totalSize = "Total Size ".concat((0, _getDisplayBytes.default)(total.size));
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "assets-summary-footer"
    }, /*#__PURE__*/_react.default.createElement("span", null, "".concat(totalQuantity, "  |  ").concat(totalSize)))
  );
}

var _default = (0, _react.memo)(AssetsSummaryFooter);

exports.default = _default;